export const dateInputValue = (value) => {
  const year = value.getFullYear();
  const month = String(value.getMonth() + 1).padStart(2, "0");
  const day = String(value.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
};

export const today = () => dateInputValue(new Date());

export const calculateDueDate = (loanDate, termDays) => {
  if (!loanDate || !termDays) {
    return "";
  }

  const [year, month, day] = loanDate.split("-").map(Number);
  const dueDate = new Date(year, month - 1, day);
  dueDate.setDate(dueDate.getDate() + Number(termDays));

  return dateInputValue(dueDate);
};

export const formatMoney = (value) => {
  return new Intl.NumberFormat("en-MY", {
    style: "currency",
    currency: "MYR",
  }).format(Number(value) || 0);
};

export const blankLoanForm = () => ({
  loan_amount: "",
  interest_amount: "",
  deposit_amount: "",
  stamp_duty: "",
  loan_date: today(),
  term_days: "",
  remarks: "",
});

export const loanCalculations = (form) => {
  const loanAmount = Number(form.loan_amount || 0);
  const deposit = Number(form.deposit_amount || 0);
  const cashOnHand = loanAmount
    - Number(form.interest_amount || 0)
    - deposit
    - Number(form.stamp_duty || 0);

  return {
    cashOnHand,
    outstanding: loanAmount - deposit,
    dueDate: calculateDueDate(form.loan_date, form.term_days),
  };
};

export const loanPayload = (form) => ({
  ...form,
  loan_amount: Number(form.loan_amount),
  interest_amount: Number(form.interest_amount),
  deposit_amount: Number(form.deposit_amount),
  stamp_duty: Number(form.stamp_duty),
  term_days: Number(form.term_days),
});